import { ArrowRight, ShieldCheck, Snowflake } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/ed2227e8-f42f-486d-80b3-32e833e48098/images/f412d0965cd05c3fb42cce1384bd43b341c945c62f3eb850b1bb60c83929df86.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      <img
        src={HERO_BG}
        alt="Snow-covered luxury driveway in Ottawa cleared by Capital Shield"
        className="absolute inset-0 h-full w-full object-cover object-center"
        loading="eager"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(5,11,20,0.6) 0%, rgba(5,11,20,0.45) 35%, rgba(5,11,20,0.85) 75%, #050B14 100%)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(70% 50% at 20% 100%, rgba(11,27,61,0.6) 0%, rgba(5,11,20,0) 60%)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-40 pb-24 md:pt-48 md:pb-32">
        <div className="max-w-3xl">
          <div className="reveal hairline mb-8">
            <span data-testid="hero-eyebrow">Ottawa · Since 2019</span>
          </div>

          <h1
            className="reveal reveal-d1 font-display text-4xl sm:text-5xl lg:text-7xl font-bold leading-[0.95] tracking-tight text-white"
            data-testid="hero-title"
          >
            Winter is fierce.
            <br />
            <span className="text-[#C9A24B]">Your driveway</span> shouldn't be.
          </h1>

          <p
            className="reveal reveal-d2 mt-8 max-w-xl text-base md:text-lg text-white/75 leading-relaxed"
            data-testid="hero-subtitle"
          >
            Capital Shield delivers professional snow removal, salting & de-icing, and
            driveway sealing across Ottawa. One trusted crew. All season long.
          </p>

          <div className="reveal reveal-d3 mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#pricing"
              data-testid="hero-cta-quote"
              className="group inline-flex items-center gap-2 px-7 py-4 bg-[#C9A24B] hover:bg-[#E0B962] text-[#050B14] font-semibold text-sm tracking-wide transition-colors"
            >
              Book Online
              <ArrowRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-services"
              className="inline-flex items-center gap-2 px-7 py-4 border border-white/25 hover:border-[#C9A24B] hover:text-[#C9A24B] text-white font-medium text-sm tracking-wide transition-colors"
            >
              Explore Services
            </a>
          </div>

          <div className="reveal reveal-d4 mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
            <Stat icon={<ShieldCheck size={18} />} value="Fully Insured" label="Liability & WSIB" />
            <Stat icon={<Snowflake size={18} />} value="24/7 Response" label="Storm-event ready" />
            <Stat
              icon={<span className="font-display text-lg leading-none">5★</span>}
              value="Local Trust"
              label="Ottawa families & businesses"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ icon, value, label }) {
  return (
    <div className="flex items-start gap-3">
      <div className="mt-0.5 text-[#C9A24B]">{icon}</div>
      <div>
        <div className="text-sm font-semibold text-white">{value}</div>
        <div className="text-xs text-white/60 mt-1">{label}</div>
      </div>
    </div>
  );
}
